





$( "#hoverzoom img" ).each(function() {
  
  $(this).click(function (evt)
    {
        evt.preventDefault(); 
        return false;  
    } 
);
  
 $(this).on('mouseover', function(){
  $(this).parent().addClass('is-hover');
   $(this).addClass('zooom');
}).on('mouseout', function(){
  $(this).parent().removeClass('is-hover');
   $(this).removeClass('zooom');
})
 
 
  
 var el = $(this);

$("#hoverzoom").mouseover(function(){
  
  el.mousemove(function(e) {
    $(this).css('object-position', -e.offsetX + "px " + -e.offsetY + "px")
  });
  
});


el.mouseout(function(){
    $(this).css('object-position', 0 + "px " + 0 + "px")
});

});